import { render } from "./FpuiInputDropzone.vue?vue&type=template&id=b176687e&lang=pug"
import script from "./FpuiInputDropzone.vue?vue&type=script&lang=js"
export * from "./FpuiInputDropzone.vue?vue&type=script&lang=js"

import "./FpuiInputDropzone.vue?vue&type=style&index=0&id=b176687e&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__